import * as React from 'react';
import { st, classes } from './ShareButton.st.css';
import { ButtonProps } from '../Button';
import { TextButton } from '../TextButton';
import { TextButtonPriority } from '../TextButton/types';
import { Share } from '@wix/wix-ui-icons-common/on-stage';
import { ShareButtonProps } from './types';

/** Opens navigator.share where available */
export class ShareButton extends React.Component<ShareButtonProps> {
  static displayName = 'ShareButton';

  onButtonClick: ButtonProps['onClick'] = () => {
    let sharePromise: Promise<void> | undefined;
    const { shareData } = this.props;

    if (navigator.share) {
      sharePromise = navigator.share(shareData);
    }
    this.props.onClick(sharePromise);
  };

  render() {
    const { shareData, text, withIcon, className, disabled, ...rest } =
      this.props;
    return (
      <TextButton
        className={st(classes.root, { withIcon }, className)}
        priority={TextButtonPriority.secondary}
        prefixIcon={
          withIcon ? (
            <Share className={st(classes.icon, { disabled })} />
          ) : undefined
        }
        disabled={disabled}
        {...rest}
        onClick={this.onButtonClick}
        data-hook={this.props['data-hook']}
      >
        <div className={classes.text}>{text}</div>
      </TextButton>
    );
  }
}
